import { render, staticRenderFns } from "./CompanyForm.vue?vue&type=template&id=a1565d5e&"
import script from "./CompanyForm.vue?vue&type=script&lang=js&"
export * from "./CompanyForm.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports